export const Logo = ({ compact = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
    <svg width={compact ? 30 : 36} height={compact ? 30 : 36} viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id="lg-head" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#1D4ED8" />
          <stop offset="1" stopColor="#1E3A8A" />
        </linearGradient>
      </defs>
      <path d="M32 3 57 17v30L32 61 7 47V17Z" fill="url(#lg-head)" />
      <path d="M32 3 57 17v30L32 61 7 47V17Z" fill="none" stroke="#38BDF8" strokeOpacity=".45" strokeWidth="2" />
      <path d="M20 25l10 7-10 7" fill="none" stroke="#fff" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M35 41h11" stroke="#F97316" strokeWidth="4.5" strokeLinecap="round" />
    </svg>
    <span className="font-display font-extrabold tracking-tight text-white leading-none">
      <span className={compact ? "text-base" : "text-lg"}>
        LEARN<span className="text-sky-400">WITH</span>TAC
      </span>
      <span className="block text-[9px] font-mono2 font-medium tracking-[0.3em] text-orange-500 uppercase mt-0.5">
        1-on-1 Engineering
      </span>
    </span>
  </span>
);
